import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { B2BUserService } from '@spartacus/organization/administration/core';
import { CustomB2bUserService } from '../../spartacus/features/organization/administration/components/user/services/custom-b2b-user.service';
import { CurrentProductService, SearchBoxComponentService } from '@spartacus/storefront';
import { CustomCurrentProductService } from '../../spartacus/features/product/custom-current-product.service';
import { CustomSearchBoxComponentService } from '../../spartacus/features/misc/search-box-by-modal/search-box-component.service';
import { ExportOrderEntriesToCsvService } from '@spartacus/cart/import-export/components';
import { CustomExportOrderEntriesToCsvService } from '../../spartacus/features/cart/import-export/components/export-entries';
import { AuthRedirectService, ProductAdapter } from '@spartacus/core';
import { CustomAuthRedirectService } from './custom-auth-redirect.service';
import { CustomOccProductAdapter } from '../../spartacus/features/product/_core/occ-product.adapter';

@NgModule({
  imports: [CommonModule],
  providers: [
    {
      provide: B2BUserService,
      useClass: CustomB2bUserService,
    },
    {
      provide: CurrentProductService,
      useClass: CustomCurrentProductService,
    },
    {
      provide: SearchBoxComponentService,
      useClass: CustomSearchBoxComponentService,
    },
    {
      provide: ExportOrderEntriesToCsvService,
      useClass: CustomExportOrderEntriesToCsvService,
    },
    {
      provide: AuthRedirectService,
      useClass: CustomAuthRedirectService,
    },
    {
      provide: ProductAdapter,
      useExisting: CustomOccProductAdapter,
    },
  ],
})
export class OverrideSpartacusServicesModule {}
